import { render, staticRenderFns } from "./PickerColor.vue?vue&type=template&id=0e58d3ce&"
import script from "./PickerColor.vue?vue&type=script&lang=js&"
export * from "./PickerColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports